/*
 * Public API Surface of @miq/auto-calculation
 *
 * Phase 3 (skeleton): module + token + adapters. Phase 4 adds the listener factories and services.
 */
export { AutoCalculationModule } from './lib/auto-calculation.module';
export { AUTO_CALC_CONFIGS_TOKEN, AutoCalculationConfiguration } from './lib/auto-calculation.token';
export { ColumnIdMap, IdentityColumnIdMap } from './lib/adapters/column-id-map';
export { FormGroupCalculationContext } from './lib/adapters/form-group.adapter';
export {
  ColumnSectionCalculationContext,
  CatalogColumnLike,
  CatalogSectionLike,
} from './lib/adapters/column-section.adapter';
export { AutoCalcDispatcher, NoopAutoCalcDispatcher } from './lib/adapters/ngxs.adapter';
export {
  UomPort,
  UomAmount,
  MessagePort,
  CatalogStatePort,
  CatalogColumnSnapshot,
  LocaleContext,
} from './lib/ports/auto-calc-ports';
export { AutoCalcOrchestratorService, bindRule, bindRules } from './lib/listeners/auto-calc-orchestrator.service';
export { bindMinMaxValidation } from './lib/listeners/min-max-validation.binder';
export { bindSaleAggregate, AggregateKernel } from './lib/listeners/sale-aggregate.binder';
export {
  createAvailabilityRatesBinders,
  AvailabilityRatesBinders,
  RatesColumnLike,
} from './lib/listeners/availability-rates.binder';
export {
  SpaceTermsAutoCalcBinder,
  SpaceTermsControls,
  SpaceTermsUomColumns,
  AutoSelectUomFn,
} from './lib/listeners/space-terms.binder';
export { PropertyTotalsBinder, PropertyTotalsPorts } from './lib/listeners/property-totals.binder';

// Re-export the calc-core surface so host code can import rules + FieldKey from one place.
export * from '@marketiq/calc-core';
